/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";
import { Form } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";

import { connect } from "react-redux";

import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { actionInsufficientInformationTask } from "../actions";
import { FollowUpInsufficientInformationModel } from "../models";
import { ApplicationState } from "../../applicationState";
import { OhCase } from "../../crud/ohCase";
import { ohCaseSelector } from "../../crud/ohCase/selectors";
import { OhCaseAuthorizer } from "../../crud/ohCase/OhCaseAuthorizer";
import { CurrentUser } from "../../auth";
import { ACTION_INSUFFICIENT_INFORMATION_TASK } from "../actionTypes";

interface DispatchProps {
    onActionTask: (model: FollowUpInsufficientInformationModel) => void;
}

interface StateProps {
    insufficientInformationTaskId: string;
    ohCase: OhCase;
    user: CurrentUser;
}

interface MergedProps {
    onSubmit: (notes: string) => void;
    ohCase: OhCase;
    user: CurrentUser;
}

interface State {
    notes: string;
}

class InsufficientInformationActionFormUnconnected extends React.Component<MergedProps, State> {
    constructor(props: MergedProps) {
        super(props);
        this.state = { notes: "" };
        this.updateTaskComments = this.updateTaskComments.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    public render() {
        if (!OhCaseAuthorizer.isAuthorizedToUpdate(this.props.ohCase, this.props.user)) {
            return null;
        }
        return (
            <Form className="tasks-actions">
                <Input.Textarea
                    value={this.state && this.state.notes}
                    label="Comments"
                    onChange={this.updateTaskComments}
                />
                <IsLoadingButton
                    content="Submit Comments"
                    floated="right"
                    onClick={this.onSubmit}
                    className="button"
                    requestNames={ACTION_INSUFFICIENT_INFORMATION_TASK}
                />
            </Form>
        );
    }

    private updateTaskComments(value: string) {
        this.setState({ notes: value });
    }

    private onSubmit() {
        this.props.onSubmit(this.state.notes);
    }
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    insufficientInformationTaskId: state.actionableTask && state.actionableTask.taskId,
    ohCase: ohCaseSelector(state),
    user: state.currentUser
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    onActionTask: (model: FollowUpInsufficientInformationModel) => dispatch(actionInsufficientInformationTask(model))
});

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps): MergedProps => ({
    ohCase: stateProps.ohCase,
    user: stateProps.user,
    onSubmit: (notes: string) => dispatchProps.onActionTask({
        insufficientInformationTaskId: stateProps.insufficientInformationTaskId,
        ohCaseId: stateProps.ohCase && stateProps.ohCase.id,
        notes
    })
});

/**
 * @deprecated Replaced by InsufficientInformationActionForm when FeatureToggleNames.EnableEnhancedInsufficientInformationFunctionality is toggled on
 */
export const OldInsufficientInformationActionForm = connect(mapStateToProps, mapDispatchToProps, mergeProps)(InsufficientInformationActionFormUnconnected);
